const cep = (state = [], action) => {
  switch (action.type) {
    case "GETCEP":
      return {
        type: "GETCEP",
        cep: action.cep,
      };
    case "CLEAR_GETCEP":
      return [];
    default:
      return state;
  }
};

export default cep;
